<template>
    <transition name="ps-fade">
        <div
            class="ps-overlay"
            v-if="showModal"
            @click.self="closeModal"
        >
            <div
                class="ps-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="ps-title"
            >
                <div class="ps-dialog-header">
                    <div>
                        <h2 class="ps-dialog-title" id="ps-title">
                            Seleccionar perfil
                        </h2>
                        <p class="ps-dialog-subtitle">
                            Elige con qué perfil deseas ingresar.
                        </p>
                    </div>
                    <button
                        class="ps-close-btn"
                        @click="closeModal"
                        aria-label="Cerrar"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                        >
                            <path
                                d="M14 4L4 14M4 4l10 10"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                        </svg>
                    </button>
                </div>

                <div class="ps-dialog-body">
                    <perfiles />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Perfiles from '@/components/Login/Perfiles.vue';

export default {
    components: { Perfiles },
    computed: {
        showModal() {
            return this.$store.state.ui.modals.seleccionarPerfil;
        },
    },
    methods: {
        closeModal() {
            this.$store.dispatch('ui/setisModalSeleccionarPerfil', false);
        },
    },
};
</script>

<style scoped>
.ps-overlay {
    position: fixed;
    inset: 0;
    background: rgba(8, 18, 38, 0.52);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
    font-family: 'Poppins', 'Segoe UI', sans-serif;
}

.ps-dialog {
    background: #ffffff;
    border-radius: 24px;
    width: min(520px, 100%);
    max-height: min(640px, calc(100vh - 64px));
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow:
        0 20px 60px rgba(8, 18, 38, 0.18),
        0 4px 16px rgba(8, 18, 38, 0.08);
    animation: ps-slide-up 0.22s ease-out;
}

@keyframes ps-slide-up {
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.ps-dialog-header {
    padding: 24px 28px 20px;
    border-bottom: 1px solid #d7deea;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-shrink: 0;
}

.ps-dialog-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #18212f;
    margin: 0 0 4px;
    line-height: 1.2;
}

.ps-dialog-subtitle {
    font-size: 14px;
    color: #69778a;
    margin: 0;
    line-height: 1.5;
}

.ps-close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    color: #69778a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 12px;
    transition: background 0.15s ease, color 0.15s ease;
}

.ps-close-btn:hover {
    background: rgba(24, 66, 137, 0.06);
    color: #184289;
}

.ps-dialog-body {
    overflow-y: auto;
    flex: 1;
    padding: 20px 28px 24px;
}

.ps-dialog-body::-webkit-scrollbar {
    width: 6px;
}
.ps-dialog-body::-webkit-scrollbar-track {
    background: transparent;
}
.ps-dialog-body::-webkit-scrollbar-thumb {
    background: #d7deea;
    border-radius: 3px;
}
.ps-dialog-body::-webkit-scrollbar-thumb:hover {
    background: #b0bad0;
}

/* Fade transition del overlay */
.ps-fade-enter-active,
.ps-fade-leave-active {
    transition: opacity 0.22s ease-out;
}
.ps-fade-enter,
.ps-fade-leave-to {
    opacity: 0;
}
</style>
